module.exports = __webpack_public_path__ + "static/media/play-player-multimedia-svgrepo-com.77777ee3.svg";